import { render, staticRenderFns } from "./NoFollowRenderer.vue?vue&type=template&id=68256ce0&scoped=true&"
import script from "./NoFollowRenderer.vue?vue&type=script&lang=js&"
export * from "./NoFollowRenderer.vue?vue&type=script&lang=js&"
import style0 from "./NoFollowRenderer.vue?vue&type=style&index=0&id=68256ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68256ce0",
  null
  
)

/* custom blocks */
import block0 from "./NoFollowRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports